<template lang="jade">
  include ./mixin.jade
  .row
    .col-xs-12
      fieldset
        legend dxGetMixerStatus
        button(@click="dxGetMixerStatus") dxGetMixerStatus
  .row
    .col-xs-12
      fieldset
        legend dxGetProfiles
        input.thin(v-model="profileKey")
        br
        button(@click="dxGetProfiles") dxGetProfiles
  .row
    .col-xs-12
      fieldset
        legend dxSetProfiles
        div
          span no:
          input(type='text' v-model='profile.pid')
        div
          span name:
          input(type='text' v-model='profile.content.name')
        div(v-for="(id, val) in profile.content.mapping" track-by="$index")
          span mapping: {{ id }}
          input(v-model="val")
        div(v-for="(id, slv) in profile.content.layer" track-by="$index")
          span layer index : {{ id + 1 }}
          input.thin(number v-model="slv" track-by="$index" )
        div(v-for="(id, sval) in profile.content.split" track-by="$index")
          span split: {{ id }}
          input.thin(number v-model="v" v-for="v in sval" track-by="$index" )
        button(@click="dxSetProfiles") dxSetProfiles
  .row
    .col-xs-12
      fieldset
        legend dxSetDeviceByProfileKey
        div
          span Profile:
          input(type='text' v-model="setProfileKey")
        button(@click="dxSetDeviceByProfileKey") dxSetDeviceByProfileKey
  +simpleGetButton('dxGetOutputSound')
  .row
    .col-xs-12
      fieldset
        legend dxSetOutputSound
        +simpleInput('sound.SoundFrom')
        +simpleInput('sound.RLChannel')
        +simpleInput('sound.FullScreenAudio')(type='checkbox')
        +simpleInput('sound.Mute')(type='checkbox')
        button(@click="dxSetOutputSound") dxSetOutputSound
  +simpleGetButton('dxGetOutputVideo')
  .row
    .col-xs-12
      fieldset 
        legend dxSetOutputVideo
        +simpleInput('video.VerticalFlip')(type='checkbox')
        +simpleInput('video.Mirror')(type='checkbox')
        button(@click="dxSetOutputVideo") dxSetOutputVideo

  +simpleGetButton('dxGetOutputColor')
  .row
    .col-xs-12
      fieldset 
        legend dxSetOutputColor
        +simpleInput('color.Brightness')(number)
        +simpleInput('color.Saturation')(number)
        +simpleInput('color.Contrast')(number)
        button(@click="dxSetOutputColor") dxSetOutputColor
  +simpleGetButton('dxGetInputResolution')
  +simpleGetButton('dxGetOutputResolutionOptions')
  +simpleGetButton('dxGetOutputResolution')
  .row
    .col-xs-12
      fieldset
        legend dxSetOutputResolution
        +simpleInput('outputRes.port')
        +simpleInput('outputRes.option')
        button(@click="dxSetOutputResolution") dxSetOutputResolution
  +simpleGetButton('dxGetSplitOptions')
  +simpleGetButton('dxGetSplitLayer')
  .row
    .col-xs-12
      fieldset
        legend dxSetSplitLayer

        div(v-for="(id, slv) in splitLayer" track-by="$index")
          span layer index : {{ id + 1 }}
          input.thin(number v-model="slv" track-by="$index" )
        button(@click="dxSetSplitLayer") dxSetSplitLayer
  +simpleGetButton('dxGetSplitArea')
  .row
    .col-xs-12
      fieldset
        legend dxSetSplitArea
        div
          label Port
          input.thin(number v-model='splitAreaPort')
        div(v-for="(id, sval) in splitArea" track-by="$index")
          span port : {{ id }}
          input.thin(number v-model="v" v-for="v in sval" track-by="$index" )
        button(@click="dxSetSplitArea") dxSetSplitArea
  +simpleGetButton('dxGetMixerStatus')
  .row
    .col-xs-12
      fieldset
        legend dxSetMapping
        div
          label Port
          input.thin(number v-model="mappingPort")
        div(v-for="(id, sval) in mapping" track-by="$index")
          span port : {{ id }}
          input.thin(v-model="sval" track-by="$index" )
        button(@click="dxSetMapping") dxSetMapping
  +simpleGetButton('dxGetLabel')
  .row
    .col-xs-12
      fieldset
        legend dxSetLabel
        div(v-for="(key, content) in label" track-by="$index")
          
          div(v-if="key !== 'osd'")
            span {{ key }} :
            div
              label Port
              input(number v-model="labelPort[key]")
            div(v-for="(id, vals) in content" track-by="$index")
              span {{ id }} :
              span
                | text
                input.thin(v-model="vals.text" )
              span
                | enabled
                input.thin(type="checkbox" v-model="vals.enabled" )
          div(v-else)
            span {{key}}:
            div
              label Port
              input(number v-model="labelPort[key]") 
            div(v-for="(id, vals) in content" track-by="$index")
              span {{ id }}:
              span
                | enabled
                input.thin(type="checkbox" v-model="vals.enabled")
              span
                | border
                input.thin(number v-model="vals.border")
        button(@click="dxSetLabel") dxSetLabel
  +simpleGetButton('dxGetInputCrop')
  .row
    .col-xs-12
      fieldset
        legend dxSetInputCrop
        div
          label Port
          input(number v-model='cropPort')
        div(v-for="(key, content) in crop" track-by="$index")
          div crop:{{ key }}
          span
            | enabled
            input.thin(type="checkbox" v-model="content.enabled" )
          div
            span H
            span(v-for="h in content.H" track-by="$index")
              input.thin(number v-model="h" )
          div
            span V
            span(v-for="v in content.V" track-by="$index")
              input.thin(number v-model="v" )
        button(@click="dxSetInputCrop") dxSetInputCrop
  +simpleGetButton('dxGetSplitOptions')
  .row
    .col-xs-12
      fieldset
        legend dxSetSplitByOption
        div.row_space--xxs
          v-select(v-bind:options='splitOptions', v-bind:value.sync='currentSplit')
        button(@click="dxSetSplitByOption") dxSetSplitByOption
  .row
    .col-xs-12
      fieldset
        legend For test only
        +simpleGetButton('dxGetCurrentSplit')

</template>

<style scoped>
  .thin {
    width: 16%;
  }
</style>
<script>
  import singleSelect from 'src/components/Single-Select'
  export default {
    components: {
      'v-select': singleSelect
    },
    data: () => ({
      profileKey: '1',
      setProfileKey: '1',
      profile: {
        pid: '1',
        content: {
          name: 'custom 1',
          mapping: {
            1: '4',
            2: '4',
            3: '4',
            4: '4'
          },
          layer: [1, 3, 2, 4],
          split: {
            1: [0, 0, 960, 540, 0],
            2: [960, 0, 1920, 540, 0],
            3: [0, 540, 960, 1080, 0],
            4: [960, 540, 1920, 1080, 0]
          }
        }
      },
      sound: {
        SoundFrom: '1',
        RLChannel: '1',
        FullScreenAudio: true,
        Mute: false
      },
      video: {
        VerticalFlip: false,
        Mirror: false
      },
      color: {
        Brightness: 50,
        Saturation: 50,
        Contrast: 50
      },
      outputRes: {
        port: '1',
        option: '3'
      },
      splitLayer: [1, 2, 3, 4],
      splitAreaPort: 1,
      splitArea: {
        1: [0, 0, 960, 540, 0],
        2: [960, 0, 1920, 540, 0],
        3: [0, 540, 960, 1080, 0],
        4: [960, 540, 1920, 1080, 0]
      },
      mappingPort: 1,
      mapping: {
        1: '3',
        2: '3',
        3: '3',
        4: '3'
      },
      labelPort: {
        'osd': 1,
        'windows': 1,
        'inputs': 1,
        'custom': 1
      },
      label: {
        'osd': {
          '1': { 'enabled': true, 'border': 0 },
          '2': { 'enabled': true, 'border': 1 },
          '3': { 'enabled': true, 'border': 2 },
          '4': { 'enabled': false, 'border': 0 }
        },
        'windows': {
          '1': {'text': 'A', 'enabled': true},
          '2': {'text': 'B', 'enabled': true},
          '3': {'text': 'C', 'enabled': true},
          '4': {'text': 'D', 'enabled': true}
        },
        'inputs': {
          '1': {'text': '1', 'enabled': true},
          '2': {'text': '2', 'enabled': true},
          '3': {'text': '3', 'enabled': true},
          '4': {'text': '4', 'enabled': true}
        },
        'custom': {
          '1': {'text': 'Custom 1', 'enabled': false},
          '2': {'text': 'Custom 2', 'enabled': false},
          '3': {'text': 'Custom 3', 'enabled': false},
          '4': {'text': 'Custom 4', 'enabled': false}
        }
      },
      cropPort: 1,
      crop: {
        1: {enabled: true, H: [1, 3, 4], V: [1, 1, 1]},  // enabled: true=crop
        2: {enabled: true, H: [1, 3, 4], V: [1, 1, 1]},  // HV: [from: to: divide]
        3: {enabled: false, H: [1, 1, 1], V: [1, 1, 1]}, // divide range: 1~255
        4: {enabled: false, H: [1, 1, 1], V: [1, 1, 1]}  // from&to range:1~divide
      },
      splitOptions: [
        {label: 'PAP1', value: 'PAP1'},
        {label: 'PAP2', value: 'PAP2'},
        {label: 'PAP3', value: 'PAP3'},
        {label: 'PAP4', value: 'PAP4'},
        {label: 'PAP5', value: 'PAP5'},
        {label: 'Full-A', value: 'Full-A'},
        {label: 'Full-B', value: 'Full-B'},
        {label: 'Full-C', value: 'Full-C'},
        {label: 'Full-D', value: 'Full-D'}
      ],
      currentSplit: 'PAP1'
    }),
    methods: {
      sendAPI (cmd, params) {
        this.$dispatch('sendAPI', cmd, params)
      },
      dxGetProfiles () {
        this.sendAPI('dxGetProfiles', { profile: this.profileKey })
      },
      dxGetMixerStatus () {
        this.sendAPI('dxGetMixerStatus')
      },
      dxSetProfiles () {
        let profiles = {
          [this.profile.pid]: this.profile.content
        }
        this.sendAPI('dxSetProfiles', { profiles })
      },
      dxSetOutputSound () {
        this.sendAPI('dxSetOutputSound', { sound: this.sound })
      },
      dxSetOutputVideo () {
        this.sendAPI('dxSetOutputVideo', { video: this.video })
      },
      dxSetOutputColor () {
        this.sendAPI('dxSetOutputColor', { color: this.color })
      },
      dxSetOutputResolution () {
        this.sendAPI('dxSetOutputResolution', {
          resolution: {
            [this.outputRes.port]: this.outputRes.option
          }
        })
      },
      dxSetSplitLayer () {
        this.sendAPI('dxSetSplitLayer', {
          layer: this.splitLayer
        })
      },
      dxSetSplitArea () {
        this.sendAPI('dxSetSplitArea', {
          setting: {
            [this.splitAreaPort]: this.splitArea[this.splitAreaPort]
          }
        })
      },
      dxSetMapping () {
        this.sendAPI('dxSetMapping', {
          mapping: {
            [this.mappingPort]: this.mapping[this.mappingPort]
          }
        })
      },
      dxSetLabel () {
        this.sendAPI('dxSetLabel', {
          osd: {
            [this.labelPort['osd']]: this.label.osd[this.labelPort['osd']]
          },
          windows: {
            [this.labelPort['windows']]: this.label.windows[this.labelPort['windows']]
          },
          inputs: {
            [this.labelPort['inputs']]: this.label.inputs[this.labelPort['inputs']]
          },
          custom: {
            [this.labelPort['custom']]: this.label.custom[this.labelPort['custom']]
          }
        })
      },
      dxSetInputCrop () {
        this.sendAPI('dxSetInputCrop', {
          crop: {
            [this.cropPort]: this.crop[this.cropPort]
          }
        })
      },
      dxSetSplitByOption () {
        this.sendAPI('dxSetSplitByOption', {
          options: {
            '1': this.currentSplit
          }
        })
      },
      dxSetDeviceByProfileKey () {
        this.sendAPI('dxSetDeviceByProfileKey', {
          profile: this.setProfileKey
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// mixer.vue?6f5584d3